import { Col, Row } from "react-bootstrap";
import { ContactMeBloc } from "../blocs/contact-me/ContactMeBloc";
import { ContactMeState } from "../blocs/contact-me/contactMeStates";
import useCubit from "../blocs/hooks";
import CenterComponent from "./CenterComponent";
import { LoadingData } from "./LoadingData";
import SomethingWentWrong from "./core/SomethingWentWrong";
const contactMeBloc = new ContactMeBloc();

export default function ContactMe() {
    const state = useCubit<ContactMeState>(contactMeBloc);
    if (state.state === 'LOADING') {
        return <LoadingData />
    } else if (state.state === 'ERROR') {
        return <SomethingWentWrong />
    }
    return <CenterComponent>
        <div style={{
            borderWidth: 1,
            borderColor: "#d2d2d2",
            borderStyle: "solid",
            padding: 18,
            borderRadius: 8,
        }}>
            <Row>
                {
                    state.data?.image
                    && <Col xs={3}>
                        <img 
                        src={state.data!.image}
                        alt="my-face"
                        style={{
                            width: "100%",
                        }} />
                    </Col>
                }
                <Col>
                    <Row><h1>{state.data!.fullName}</h1></Row>
                    <Row><h2>{state.data!.currentPosition}</h2></Row>
                    <Row><h3>{state.data!.message}</h3></Row>
                    {state.data?.email && <Row><h3>Email: <a href={`mailto:${state.data!.email}`}>{state.data!.email}</a></h3></Row>}
                    {state.data?.linkedinUrl && <Row><h3>Linkedin: <a href={state.data!.linkedinUrl}>{state.data!.linkedinUrl}</a></h3></Row>}
                    {state.data?.githubUrl && <Row><h3>Github: <a href={state.data!.githubUrl}>{state.data!.githubUrl}</a></h3></Row>}
                    {state.data?.twitterUrl && <Row><h3>Twitter: <a href={state.data!.twitterUrl}>{state.data!.twitterUrl}</a></h3></Row>}
                </Col>
            </Row>
        </div>
    </CenterComponent>
}